export default __webpack_public_path__ + "5a0528b7b335bf4c6d6fc128c59b6e1e.png";